import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { ErrorBoundary } from "Infrastructure/Utilities/ErrorBoundary/ErrorBoundary";
import { Sidebar } from "Shared/Components/Layout/Full/Sidebar/Sidebar";
import { Box, Container, styled } from "@mui/material";
import { useAtom } from "jotai";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

const MainWrapper = styled("div")(() => ({
	display: "flex",
	minHeight: "100vh",
	width: "100%",
}));

export const PageWrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== "$sidebarWidth",
})<{ $sidebarWidth?: number }>`
  display: flex;
  padding-bottom: 60px;
  flex-direction: column;
  z-index: 1;
  width: ${(props) => `calc(100% - ${props.$sidebarWidth}px)`};
  background-color: transparent;
`;

export function FullLayout() {
	const [themeConfiguration] = useAtom(themeAtom);
	const sidebarWidth = () => {
		if (!themeConfiguration.isCollapse || themeConfiguration.isSidebarHover) {
			return themeConfiguration.SidebarWidth;
		}
		return themeConfiguration.MiniSidebarWidth;
	};

	return (
		<MainWrapper
			className={
				themeConfiguration.activeMode === "dark"
					? "darkbg mainwrapper"
					: "mainwrapper"
			}
		>
			<Toaster richColors position="top-left" />
			<Sidebar />
			<PageWrapper className="page-wrapper" $sidebarWidth={sidebarWidth()}>
				<Container sx={{ pt: "2rem" }} maxWidth={false}>
					<Box sx={{ minHeight: "calc(100vh - 170px)" }}>
						<ErrorBoundary>
							<Outlet />
						</ErrorBoundary>
					</Box>
				</Container>
			</PageWrapper>
		</MainWrapper>
	);
}
